"use strict";
var appn;
(function (appn) {
    var devWidget;
    (function (devWidget) {
        function init() {
            $('.appnDevWidget input').removeAttr('disabled');
            $('.appnDevWidget input').removeAttr('readonly');
            addEvents();
        }
        devWidget.init = init;
        function addEvents() {
            $('.btnExpandAllCards').on('click', function () {
                $('.collapsed-card.card [data-card-widget=\'collapse\']').click();
            });
            $('.btnCollapseAllCards').on('click', function () {
                $('.card:not(.collapsed-card) [data-card-widget=\'collapse\']').click();
            });
        }
        function getUserDevices() {
            const devices = [];
            const table = $('#userDevices').find('table');
            const rows = table.find('tbody').find('tr');
            rows.each((i, e) => {
                var _a, _b, _c, _d;
                const userDevice = new Array();
                userDevice.push((_a = $(e).children().get(0)) === null || _a === void 0 ? void 0 : _a.innerText);
                userDevice.push((_b = $(e).children().get(1)) === null || _b === void 0 ? void 0 : _b.innerText);
                userDevice.push((_c = $(e).children().get(2)) === null || _c === void 0 ? void 0 : _c.innerText);
                userDevice.push((_d = $(e).children().get(3)) === null || _d === void 0 ? void 0 : _d.innerText);
                userDevice.push($(e).find('button').attr('id'));
                devices.push(userDevice);
            });
            return devices;
        }
        function widgetShortcut(event) {
            $('.btn-control-sidebar').click();
        }
        devWidget.widgetShortcut = widgetShortcut;
    })(devWidget = appn.devWidget || (appn.devWidget = {}));
})(appn || (appn = {}));
